import { toast } from 'react-toastify';
import { logout } from '../store/authSlice';
import axiosInstance from './axios';

/**
 * Method to handle errors.
 */
const responseErrorHandler = (store: any, error: any) => {
    const { response, config } = error;
    // an ended subscription already shows the renew page, so no toast for it
    const planEnded = response?.status === 402 && response.data?.code === 'SUBSCRIPTION_EXPIRED';
    const silent = config?.headers?.['x-silent'] === '1' || config?._silent || planEnded;
    if (response) {
        if (!silent) {
            const message = response.data.message || response.data;
            // same message from parallel requests shows once
            toast.error(message, { toastId: typeof message === 'string' ? message : undefined });
        }

        // If user is not authenticated then redirect the user to login page.
        if (response?.status === 401 && !window.location.pathname.startsWith('/account/create-basic-info')) {
            store.dispatch(logout());
        }
    } else if (!silent) {
        toast.error(error.message);
    }

    return Promise.reject(error);
}

/**
 * Method to add api response interceptor and handle errors.
 */
const setupApiResponseInterceptors = (store: any) => {
    // Add a response interceptor to handle errors at one place.
    axiosInstance.interceptors.response.use(
        (response) => response,
        (error) => responseErrorHandler(store, error),
    );
}

export default setupApiResponseInterceptors;
